import styled from "styled-components";
import { Nav, NavItem } from "react-bootstrap";

export const MajorNavWrapper = styled(Nav)`
    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        font-size: 16px;
        line-height: 20px;
    }
`;

export const InverseNavWrapper = styled(Nav)`
    & > li > a {
        font-size: 14px;
        font-weight: 500;
        // background-color: #337ab7;
        // color: white;
        // width: 160px;
        text-align: center;
        border: 1px solid #ddd;
        padding: 5px 15px;
    }

    & > li.active > a:focus {
        background-color: #337ab7;
        color: white;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        font-size: 16px;
        line-height: 20px;
        background-color: #337ab7;
        color: white;
    }
`;

interface INavItemProps {
    tabWidth?: string
}

export const MajorNavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    // }

    & > a {
        min-width: 140px;
    }
`;

export const GridWrapper = styled.div<{ width?: string, height?: string, headerBgColor?: string, headerFontColor?: string, headerFontWeight?: number }>`
    width: ${p => p.width ? p.width : '87%'};
    height: ${p => p.height ? p.height : '60vh'};

    .action-menu {
        overflow: visible;
        // border-bottom: none;
        line-height: 25px;
        // border-color: #ccc;
        display: flex;
        align-items: center;
        // padding-left: 0px;
        // padding-right: 0px;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu > .ag-react-container > div > .btn-group {
        width: 100%;
    }

    .ag-header {
        background-color: ${p => p.headerBgColor ? p.headerBgColor : '#ddd'};
        color: ${p => p.headerFontColor ? p.headerFontColor : 'white'};
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        // font-weight: ${p => p.headerFontWeight ? p.headerFontWeight : 400};
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 12px;
        display: flex;
        justify-content: center;
    }

    .center-list-cell-highlight {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 12px;
        background-color: yellow;
    }

    .center-list-header {
        // display: flex;
        justify-content: center;
        // align-items: center;
        // padding-bottom: 4px;
    }

    @media screen and (width < 1920px) {
        font-size: 12px;
    }
`;

export const RecipientsWrapper = styled.div`
    padding: 0px 10px;

    .recipient-section {
        width: 100%;
        // border-left: 1px solid #ddd;
        // border-right: 1px solid #ddd;
        // border-bottom: 1px solid #ddd;
        border: 1px solid #ddd;
        //min-height: 60vh;
        padding: 10px 5px 5px 0px;
        background-color: #FFF;
    }

    .recipient-profile-section {
        width: 100%;
        // border-left: 1px solid #ddd;
        // border-right: 1px solid #ddd;
        // border-bottom: 1px solid #ddd;
        border: 1px solid #ddd;
        // min-height: 70vh;
        padding: 10px 5px 5px 0px;
        // background-color: #FFF;
    }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    fontSize?: string,
    height?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    & > .acc-tabs > li {
        height: 48px;
    }

    & > .acc-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        text-align: center;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .recipient-pills > li > a {
        padding: 5px 7px;
    }

    & > div > .recipient-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 2px;
        color: #ccc;
    }

    & > div > .recipient-pills > li.li-divider {
        height: ${(p: INavWrapperProps) => p.height != null ? p.height : '50px;'};
        display: flex;
        align-items: center;
    }

    & > div > .recipient-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;

interface INavItemProps {
    minTabWidth?: string,
    height?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    height: ${(p: INavItemProps) => p.height ? p.height : '30px;'};
    display: flex !important;
    align-items: center;
    text-align: center;
`;